/** Same management cohort as the existing scheduled report page. */
export const REPORT_SCHEDULE_MANAGEMENT_ROLES = [
  'TENANT_ADMIN',
  'SYSTEM_ADMIN',
  'CEO',
  'OWNER',
  'OPERATIONS_DIRECTOR',
  'CLINICAL_DIRECTOR',
  'FINANCE_DIRECTOR',
  'QUALITY_DIRECTOR',
  'HR_DIRECTOR',
  'FACILITY_MANAGER',
  'QUALITY_OFFICER',
  'REGION_MANAGER',
  'REGION_COMPLIANCE_OFFICER',
  'REGION_FINANCE_OFFICER',
] as const;

export interface DashboardCalendarReviewRow {
  id: string;
  dashboard_key: string;
  frequency: string;
  day_of_week: number | null;
  day_of_month: number | null;
  fire_at_local_time: string;
  next_fire_at: string | null;
  schedule_timezone: string | null;
  next_fire_local_date: string | null;
  schedule_clock_version: number;
  schedule_error: string | null;
  is_active: boolean;
}

export function dashboardCalendarReviewCursor(value: string | undefined): string | null {
  return value && /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(value)
    ? value
    : null;
}

/** Reset local review state whenever the persisted calendar preimage changes. */
export function dashboardCalendarReviewKey(row: DashboardCalendarReviewRow): string {
  return JSON.stringify([
    row.id,
    row.schedule_clock_version,
    row.is_active,
    row.next_fire_at,
    row.next_fire_local_date,
    row.schedule_timezone,
    row.frequency,
    row.fire_at_local_time,
    row.day_of_week,
    row.day_of_month,
  ]);
}
